// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SMM8","content":"styles_content__1TWSL"};